<div class="flex flex-col full-grow-no-shrink-no-basis" style="height: 0">
  <section class="top-area" *ngIf="parentCard">
    <div class="parent-task-container">
      <mat-accordion class="custom-accordion box-appearance m-t-20">
        <mat-expansion-panel [expanded]="true">
          <mat-expansion-panel-header>
            <mat-panel-title class="header" [matTooltip]="parentCard.title">
              {{parentCard.title}}
            </mat-panel-title>
            <i class="fa-solid fa-up-right-from-square"
               (click)="handleActionEvent($event, 'defaultBodyView', parentCard)" matTooltip="Open"></i>
            <div class="m-l-10 accordion-header-right flex flex-row justify-start items-center">
              <mat-form-field class="inprogress" appearance="outline" *ngIf="!statusHidden"
                              (click)="$event.stopPropagation();">
                <mat-select
                  [disabled]="!parentCard.hasPermissionForChangeStatus"
                  [ngModel]="parentCard.status" (ngModelChange)="onTaskStatusChanges(parentCard, $event)">
                  <mat-option *ngFor="let status of statusList" [value]="status.status">
                    {{status.name}}
                  </mat-option>
                </mat-select>
              </mat-form-field>
              <ul class="header-actions-icon">
                <li *ngIf="taskMenuItemsMapper.hasOwnProperty('TaskAssignee')">
                  <a class="pointer" matTooltip="Peoples"
                     (click)="handleActionEvent($event, 'TaskAssignee', parentCard)"><i class="far fa-user-friends"></i>
                    <span class="text">{{parentCard.sharedPeoplesCount}}</span>
                  </a></li>
                <li *ngIf="taskMenuItemsMapper.hasOwnProperty('TaskAlert')"><a class="pointer "
                                                                               matTooltip="Notifications"
                                                                               (click)="handleActionEvent('TaskAlert', parentCard)"><i
                  class="far fa-clock"></i>
                  <span class="text">{{parentCard.taskAlertCount}}</span>
                </a></li>
              </ul>
            </div>
          </mat-expansion-panel-header>
          <ng-template matExpansionPanelContent>
            <app-task-sub-ticket-view [card]="parentCard"
                                      (updateTaskEvent$)="updateTask($event, true)"></app-task-sub-ticket-view>
          </ng-template>
        </mat-expansion-panel>
      </mat-accordion>
    </div>
    <!--<div *ngIf="hasOccurrencePermission" class="header-area" fxLayout="row" fxLayoutAlign="start center">-->
    <div *ngIf="parentCard.hasOccurrencePermission && !card.parentTicket"
         class="header-area m-t-10 flex flex-row justify-start items-center">
      <particle-inplace-input
        [focusEditor]="true"
        (valueChanged)='createSubTask($event);'
        placeHolder="Title"
        text=""
        [saveButtonCaption]="'Create subtask'"
      ></particle-inplace-input>
    </div>
  </section>

  <section class="bottom-area m-t-20 flex flex-col justify-start items-start full-grow-no-shrink-no-basis">
    <mat-accordion class="custom-accordion box-appearance full-grow-no-shrink-no-basis" fusePerfectScrollbar>
      <mat-expansion-panel (opened)="onExpandSubtask(item)" (closed)="onClosesSubtask(item)"
                           [expanded]="currentlyExpandedSubtaskId==item.id"
                           *ngFor="let item of subTasks; let i = index">
        <mat-expansion-panel-header>
          <mat-panel-title class="header w-p-500" [matTooltip]="item.title">
            {{item.title}}
          </mat-panel-title>
          <i class="fa-solid fa-up-right-from-square" style="font-size: 12px;"
             (click)="handleActionEvent($event, 'defaultBodyView', item)" matTooltip="Open"></i>
          <div class="m-l-10 accordion-header-right flex flex-row justify-start items-center">
            <mat-form-field class="inprogress" appearance="outline" *ngIf="!statusHidden"
                            (click)="$event.stopPropagation();">
              <mat-select
                [disabled]="!item.hasPermissionForChangeStatus"
                [ngModel]="item.status" (ngModelChange)="onTaskStatusChanges(item, $event)">
                <mat-option *ngFor="let status of statusList" [value]="status.status">
                  {{status.name}}
                </mat-option>
              </mat-select>
            </mat-form-field>
            <ul class="header-actions-icon">
              <li *ngIf="taskMenuItemsMapper.hasOwnProperty('TaskAssignee')"><a class="pointer"
                                                                                (click)="handleActionEvent($event, 'TaskAssignee', item)"
                                                                                matTooltip="Peoples">
                <i class="far fa-user-friends"></i> <span class="text">{{item.sharedPeoplesCount}}</span></a>
              </li>
              <li *ngIf="taskMenuItemsMapper.hasOwnProperty('TaskAlert')">
                <a class="pointer " (click)="handleActionEvent($event, 'TaskAlert', item)" matTooltip="Notifications"><i
                  class="far fa-clock"></i>
                  <span class="text">{{item.taskAlertCount}}</span>
                </a></li>
            </ul>
          </div>
        </mat-expansion-panel-header>
        <ng-template matExpansionPanelContent>
          <app-task-sub-ticket-view *ngIf="currentlyExpandedSubtaskId === item.id" [card]="item" id="task-sub-task-view"
                                    (updateTaskEvent$)="updateTask($event, true)"></app-task-sub-ticket-view>
        </ng-template>
      </mat-expansion-panel>
    </mat-accordion>

    <div class="pagination-container flex flex-row justify-start items-center">
      Page {{pageNo + 1}} of {{pageCount}}
      <div class="simple-pagination">

        <button mat-button class="pagination-item"
                [ngClass]="{'active': pageNo>0, 'disable': pageNo<=0}"
                value="prev_page"
                [disabled]="pageNo<=0"
                aria-label="Go to previous page"
                (click)="subtaskPagination(pageNo-1)">
          <mat-icon>chevron_left</mat-icon>
        </button>
        <button mat-button class="pagination-item"
                [ngClass]="{'active': pageNo+1<pageCount, 'disable': pageNo+1>=pageCount}"
                value="next_page"
                [disabled]="pageNo+1>=pageCount"
                aria-label="Go to next page"
                (click)="subtaskPagination(pageNo+1)">
          <mat-icon>chevron_right</mat-icon>
        </button>
      </div>
    </div>
  </section>
</div>
